import { render, staticRenderFns } from "./VesselCrew.vue?vue&type=template&id=864d93da&scoped=true&"
import script from "./VesselCrew.vue?vue&type=script&lang=js&"
export * from "./VesselCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d93da",
  null
  
)

export default component.exports